import React, { useEffect, useRef, useState } from 'react';
import {
  PageContainer,
  FilterPod,
  TableComponents,
  SimpleDialog,
  ButtonLoading,
} from 'components';
import { LabelLine } from 'components/InputV2/components';
import { Grid, Button, Select, MenuItem, InputLabel, CircularProgress, Box } from '@mui/material';
import createToast from 'components/Toast/Toast';
import { toFilterVOS, filterVOStoQueryStr } from 'components/FilterPod';
import Services from '../services';
import { columns, generateData } from '../components/Columns';
import useCustomHook from './hooks';
import axios from 'axios';
import RequestCard from '../components/RequestCard';
import { useStyles } from '../Style';
import { useNavigate } from 'react-router-dom';
import { ActiveBonCartDG } from '../components/ActiveBonCartDG';
import { useBusiness } from 'hooks';
import FilterButton from 'components/FilterPod/FilterButton';
import { constBreadCrumbsTitle } from 'utility';
// TODO: Add exporting
// TODO: Detail button is not responsive

const BonusCartList = () => {
  // -- STATES --//
  const tableRef = useRef();
  const {
    loading,
    setLoading,
    filterParams,
    setFilterParams,
    size,
    setSize,
    page, setPage,
    filters,
    setFilters,
    isRequestDialog,
    setIsRequestDialog,
    isRequestDuplicate,
    setIsRequestDuplicate,
    isRequestDuplicateConfirm,
    setIsRequestDuplicateConfirm,
    isRequestPhysicalCard,
    setRequestPhysicalCard,
    selectedRow,
    setSelectedRow,
    isRequestBlock,
    setIsRequestBlock,
    actionLoading,
    setActionLoading,
    reasonDuplicate,
    setReasonDuplicate,
    isLoadingAdressPhysicalCard,
    setLoadingAdressPhysicalCard,
    actionActiveBonCartObj,
    setActionActiveBonCartObj,
    imprestDetails,
    setImprestDetails,
  } = useCustomHook();
  const reason = {
    CardLoss: 'مفقودی',
    CardSteal: 'سرقت',
    Replacement: 'جایگزینی',
    CardExpiration: 'انقضا',
  };
  const navigate = useNavigate();
  const userDetails = useBusiness();
  // --HOOKS--//
  const classes = useStyles();

  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);

  useEffect(() => { }, []);

  // --API REQUESTS--//
  const getList = async (query) => {
    try {
      setLoading(true);
      const orderBy = [];
      const filter = toFilterVOS([...filters]);
      const queries = filterVOStoQueryStr(filter);

      const params = {
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query ? query?.pageSize : size,
        ...queries,
      };

      const data = {
        filterVOS: filter ?? [],
        parentParams: [],
        orderByElementVOS: orderBy ?? [],
      };

      setFilterParams({ data, params });

      const res = await Services.getListCart(params);

      let list = [];
      if (res.result) {
        list = generateData(res.result, {
          page: query ? query?.pageNumber : page,
          pageSize: query?.pageSize || size,
        });
      }

      setLoading(false);

      const d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count,
      };
      return d; // passed to MaterialTable
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  // -- OTHER FUNCTIONS --//
  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0)
    setSize(10)
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100)
  };

  const requsetDuplicateCart = (row) => {
    setSelectedRow(row);
    setIsRequestDuplicate(true);
  };

  const requsetBlockingCart = (row) => {
    setSelectedRow(row);
    setIsRequestBlock(true);
  };

  /**
   * دیالوگ درخواست فیزیکی کارت - اطلاعات تنخواه گردان لازم است
   */
  const requsetPhysicalCard = (row) => {
    setSelectedRow(row);
    setRequestPhysicalCard(true);
    setLoadingAdressPhysicalCard(true);
    Services.getuserInfo({ username: row?.name })
      .then((res) => {
        if (!res?.result || !Object.entries(res?.result).length) {
          createToast('خطا', 'اطلاعات کاربر یافت نشد.', 'danger');
        } else {
          setImprestDetails(res?.result);
        }
        setLoadingAdressPhysicalCard(false);
      })
      .catch((error) => {
        setLoadingAdressPhysicalCard(false);
      });
  };
  /**
   * ارسال نهایی دیالوگ چاپ فیزیکی
   */
  const onPhysicalCardRequest = () => {
    setActionLoading(true);
    const params = {
      cardNumber: selectedRow?.pan,
      payFeeByCustomer: null,
      userId: imprestDetails?.userId,
    };
    Services.requestPhysicalCardIssuance(params)
      .then((res) => {
        createToast('خطا', 'درخواست با موفقیت ثبت شد.', 'danger');

        setActionLoading(false);
        setRequestPhysicalCard(false);
        setTimeout(() => {
          tableRef?.current?.onChangeTable(true);
        }, 100)
        setTimeout(() => {
          setImprestDetails(null);
          setSelectedRow(null);
        }, 500);
      })
      .catch((error) => {
        setActionLoading(false);
      });
  };

  ///==========================================
  const BtnAction = (props) => {
    return (
      <>
        <ButtonLoading
          type="submit"
          variant="contained"
          color="primary"
          loading={actionLoading}
          name="تایید"
          onClick={() => {
            onSabtModal(props.type);
          }}
        />

        <Button
          variant="contained"
          onClick={() => {
            onCloseModal(props.type);
          }}>
          انصراف
        </Button>
      </>
    );
  };
  const onSabtModal = (type) => {
    if (type == 'Duplicate_step1') {
      setIsRequestDuplicateConfirm(true);
    } else if (type == 'Duplicate_step2') {
      onDuplicate();
    } else if (type == 'Block') {
      onBlock();
    }
  };
  const onCloseModal = (type) => {
    if (type == 'Duplicate_step1') {
      setIsRequestDuplicate(false);
      setTimeout(() => {
        setSelectedRow(null);
        setReasonDuplicate('CardLoss');
      }, 500);
    } else if (type == 'Duplicate_step2') {
      setIsRequestDuplicateConfirm(false);
    } else if (type == 'Block') {
      setIsRequestBlock(false);
      setTimeout(() => {
        setSelectedRow(null);
      }, 1000);
    }
  };
  //===============================================

  const onDuplicate = () => {
    setActionLoading(true);
    const params = {
      pan: selectedRow?.pan,
      requestCause: reasonDuplicate,
    };
    Services.requestSecondaryCardIssuance(params)
      .then((res) => {
        createToast('موفق', 'درخواست با موفقیت ثبت شد', 'success');

        setActionLoading(false);
        setIsRequestDuplicateConfirm(false);
        setIsRequestDuplicate(false);
        setTimeout(() => {
          setSelectedRow(null);
        }, 500);
      })
      .catch((error) => {
        setActionLoading(false);
      });
  };
  const onBlock = () => {
    setActionLoading(true);
    Services.blockCard(selectedRow?.pan)
      .then((res) => {
        createToast('موفق', 'درخواست با موفقیت ثبت شد', 'success');

        setActionLoading(true);
        setIsRequestBlock(false);
        setTimeout(() => {
          setSelectedRow(null);
          setReasonDuplicate('CardLoss');
        }, 500);
      })
      .catch((error) => {
        setActionLoading(false);
      });
  };

  const formatCardNumber = (no) => {
    let noStr = `${no}`;
    let arr = noStr.match(/.{1,4}/g);
    arr = arr.reverse();
    noStr = '';
    arr.map((v, k) => (noStr += `${v}${k != arr.length - 1 ? ' - ' : ''}`));
    return noStr;
  };
  /**
   * فعال سازی کارت
   */
  const actionActiveBonCart = (row) => {
    setSelectedRow(row);
    setActionActiveBonCartObj({ isShowDialog: true, step: 1 });
  };

  const refreshPage = () => {
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100)
  };


  const hint = 'در این بخش می‌توانید لیست بن‌ کارت ها  را مشاهده کنید.';

  return (
    <PageContainer
      title="لیست بن‌ کارت"
      description={hint}
      breadcrumbs={constBreadCrumbsTitle.BONUSCARD_LIST}
      className={classes.root}
      meta={
        <Button
          className={classes.cardHeaderButton}
          onClick={() => {
            setIsRequestDialog(true);
          }}
          color="primary"
          variant="contained"
        >
          درخواست صدور کارت
        </Button>
      }
    >
      <Grid item xs={12}>
        <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16 }}>
          <FilterButton
            setOpenFilterDialog={setOpenFilterDialog}
            filters={filters}
          />
        </Box>
        <Box>
          <FilterPod
            filters={filters}
            onChange={onFiltersChange}
            openFilterDialog={openFilterDialog}
            setOpenFilterDialog={setOpenFilterDialog}
            handleCloseFilterDialog={handleCloseFilterDialog}
          />
        </Box>
      </Grid>
      <TableComponents
        data={getList}
        columns={columns(
          requsetDuplicateCart,
          requsetBlockingCart,
          requsetPhysicalCard,
          actionActiveBonCart,
        )}
        ref={tableRef}
        isLoading={loading}
        onChange={(ps) => {
          setPage(ps?.pageNumber)
          setSize(ps?.pageSize)
          return getList(ps)
        }}

      />

      <SimpleDialog
        title="درخواست صدور کارت"
        open={isRequestDialog}
        onClose={() => {
          setIsRequestDialog(false);
        }}
      >
        <RequestCard onClose={() => setIsRequestDialog()} />
      </SimpleDialog>

      <SimpleDialog
        title="درخواست المثنی"
        open={isRequestDuplicateConfirm}
        actions={<BtnAction type={'Duplicate_step2'} />}
      >
        <Grid style={{ margin: '16px 0' }}>
          {`آیا از درخواست المثنی برای کارت  (${formatCardNumber(selectedRow?.pan)}) به علت  ${reason[reasonDuplicate]
            } اطمینان دارید ؟`}
        </Grid>
      </SimpleDialog>

      <SimpleDialog
        title="درخواست المثنی"
        open={isRequestDuplicate}
        actions={<BtnAction type={'Duplicate_step1'} />}
      >
        <Grid item xs={6} style={{ margin: '16px 0' }}>
          <InputLabel shrink className={classes.label}>
            <LabelLine label="علت درخواست" />
          </InputLabel>
          <Select
            fullWidth
            value={reasonDuplicate}
            onChange={(e) => {
              setReasonDuplicate(e.target.value);
            }}
            variant="outlined"
            required={true}
            style={{ height: 38 }}
            className='pureSelect'
            name="payeValue"
          >
            <MenuItem value="CardLoss">مفقودی</MenuItem>
            <MenuItem value="CardSteal">سرقت</MenuItem>
            <MenuItem value="Replacement">جایگزینی</MenuItem>
            <MenuItem value="CardExpiration">انقضا</MenuItem>
          </Select>
        </Grid>
      </SimpleDialog>

      <SimpleDialog
        title="درخواست مسدودی"
        open={isRequestBlock}
        style={{ maxWidth: 1000, minWidth: 1000 }}
        actions={<BtnAction type={'Block'} />}
      >
        <Grid style={{ margin: '16px 0' }}>
          {`آیا از مسدودی  کارت (${formatCardNumber(selectedRow?.pan)}) به نام ${selectedRow?.name
            } اطمینان دارید؟`}
        </Grid>
      </SimpleDialog>

      {/* چاپ فیزیکی ================*/}
      <SimpleDialog title="درخواست چاپ و ارسال" open={isRequestPhysicalCard}>
        <Grid
          className={classes.m8}
          style={isLoadingAdressPhysicalCard ? { textAlign: 'center' } : { maxWidth: 440 }}
        >
          {imprestDetails && !isLoadingAdressPhysicalCard && (
            <>
              <Grid>آدرس ثبت شده برای شعبه جهت ارسال کارت به شرح زیر می باشد: </Grid>
              <Grid
                style={{ margin: '32px 0', fontWeight: 'bold', display: 'flex', flexWrap: 'wrap' }}
              >
                {` " ${imprestDetails?.state} - ${imprestDetails?.city} - ${imprestDetails?.address} " `}
              </Grid>
              <Grid style={{ marginBottom: '32px' }}>آیا از آدرس ثبت شده اطمینان دارید؟</Grid>
            </>
          )}
          {isLoadingAdressPhysicalCard && (
            <CircularProgress size={24} className={classes.buttonProgress} />
          )}

          {!isLoadingAdressPhysicalCard &&
            !imprestDetails &&
            selectedRow?.physicalStatus == 'PHYSICAL_CARD_REQUEST_STATUS_LOGICALLY_ISSUED' && (
              <span style={{ marginBottom: '8px' }}>شعبه یافت نشد</span>
            )}
        </Grid>

        <Grid item style={{ display: 'flex', marginTop: '16px', flexDirection: 'row-reverse' }}>
          <>
            <ButtonLoading
              type="submit"
              variant="contained"
              color="primary"
              name="ویرایش آدرس"
              onClick={() => {
                if (imprestDetails?.isFunder) {
                  navigate(`/BusinessInfo?tab=contact&redirectUrl=BonusCart`);
                } else {
                  navigate(`/Imprest/${imprestDetails?.branchId}?redirectUrl=BonusCart`);
                }
              }}
              disabled={!imprestDetails}
            />
            <ButtonLoading
              type="submit"
              variant={!actionLoading ? 'contained' : ''}
              color="primary"
              loading={actionLoading}
              name="ارسال"
              onClick={() => {
                onPhysicalCardRequest();
              }}
              style={{ margin: '0 4px' }}
              disabled={!imprestDetails || actionLoading}
            />
            <Button
              variant="contained"
              onClick={() => {
                setRequestPhysicalCard(false);
                setImprestDetails(null);
                setSelectedRow(null);
                setTimeout(() => {
                  setImprestDetails(null);
                }, 500);
              }}>
              انصراف
            </Button>
          </>
        </Grid>
      </SimpleDialog>
      {/* ========================= */}

      <ActiveBonCartDG
        actionActiveBonCartObj={actionActiveBonCartObj}
        setActionActiveBonCartObj={setActionActiveBonCartObj}
        selectedRow={selectedRow}
        refreshPage={refreshPage}
      />
    </PageContainer>
  );
};

export default BonusCartList;
